export const BASE_URL =
  `${(window as any).__ENV__.REACT_APP_BASE_API_URL}` ||
  'http://localhost:4000';

export const RE_CAPTCHA_KEY =
  `${(window as any).__ENV__.GOOGLE_RECAPTCHA_SITE_KEY}` ||
  '6LfUuY8pAAAAAIaxlI5tjTl5hhkuok4mf5TDrQ67';

export const ENABLE_RECAPTCHA =
  (window as any).__ENV__.ENABLE_RECAPTCHA ?? true;
